module.exports = __webpack_public_path__ + "assets/HKNova-Medium.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Medium.svg
// module id = 136
// module chunks = 0